export default "__VITE_ASSET__Bn4j2Qqw__"